<template>
  <v-dialog v-if="typeof dialog!=='undefined'" v-model="loading" :width="96" persistent>
    <v-sheet class="position-relative d-flex align-center" :width="96" :height="96">
      <v-icon class="position-absolute d-block mx-auto" style="margin-left:calc(50% - 12px)!important"
              :color="$tools.isEmpty(color) ? 'primary' : color">{{ icon }}
      </v-icon>
      <v-progress-circular
          :indeterminate="$tools.isEmpty(progress) && (!$tools.isDefined(loading) || loading===true)"
          :value="$tools.isEmpty(progress) ? 0 : progress"
          class="d-block mx-auto"
          :color="$tools.isEmpty(color) ? 'primary' : color"
          size="46"
          rotate="-90"
      />
    </v-sheet>
  </v-dialog>
  <v-sheet v-else class="position-relative d-flex align-center ma-auto" :width="96" :height="96" color="transparent">
    <v-icon class="position-absolute d-block mx-auto" style="margin-left:calc(50% - 12px)!important"
            :color="$tools.isEmpty(color) ? 'primary' : color">{{ icon }}
    </v-icon>
    <v-progress-circular
        :indeterminate="$tools.isEmpty(progress) && (!$tools.isDefined(loading) || loading===true)"
        :value="$tools.isEmpty(progress) ? 0 : progress"
        class="d-block mx-auto"
        :color="$tools.isEmpty(color) ? 'primary' : color"
        size="46"
        rotate="-90"
    />
  </v-sheet>
</template>

<script>
export default {
  props: ['loading', 'progress', 'icon', 'dialog', 'color'],
}
</script>
